import { defineComponent, computed, ref, watch, createElementBlock, openBlock, normalizeClass, Fragment, createCommentVNode, createElementVNode, toDisplayString, withDirectives, vModelText } from 'vue';

const _hoisted_1 = {
  key: 0,
  class: "amount-input__label"
};
const _hoisted_2 = { class: "amount-input__value" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["id", "min", "max", "step", "disabled"];
const _hoisted_5 = ["disabled"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AmountInput",
  props: {
    id: {},
    modelValue: { default: 1 },
    min: { default: 0 },
    max: { default: 999 },
    step: { default: 1 },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    label: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const uid = computed(() => {
      return props.id || Date.now().toString(36) + Math.random().toString(36).substring(2);
    });
    const emit = __emit;
    const inputValue = ref(props.modelValue);
    watch(
      () => props.modelValue,
      (newValue) => {
        inputValue.value = newValue;
      }
    );
    const canDecrement = computed(() => {
      return !props.disabled && inputValue.value > props.min;
    });
    const canIncrement = computed(() => {
      return !props.disabled && inputValue.value < props.max;
    });
    const decrement = () => {
      if (canDecrement.value) {
        inputValue.value = Math.max(props.min, inputValue.value - props.step);
        emit("update:modelValue", inputValue.value, uid.value);
      }
    };
    const increment = () => {
      if (canIncrement.value) {
        inputValue.value = Math.min(props.max, inputValue.value + props.step);
        emit("update:modelValue", inputValue.value, uid.value);
      }
    };
    const handleInputChange = () => {
      if (inputValue.value === null || inputValue.value === void 0 || inputValue.value === "" || isNaN(inputValue.value)) {
        inputValue.value = props.min;
      } else if (inputValue.value < props.min) {
        inputValue.value = props.min;
      } else if (inputValue.value > props.max) {
        inputValue.value = props.max;
      }
      emit("update:modelValue", inputValue.value, uid.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["amount-input", { "amount-input--disabled": props.disabled, "amount-input--readonly": props.readonly }])
      }, [
        _ctx.readonly ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          _ctx.label ? (openBlock(), createElementBlock("span", _hoisted_1, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
          createElementVNode("span", _hoisted_2, toDisplayString(inputValue.value), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createElementVNode("button", {
            type: "button",
            class: "amount-input__button amount-input__button--decrement",
            disabled: !canDecrement.value,
            onClick: decrement,
            "aria-label": "Decrease amount"
          }, _cache[1] || (_cache[1] = [
            createElementVNode("span", null, "-", -1)
          ]), 8, _hoisted_3),
          withDirectives(createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
            id: uid.value,
            class: "amount-input__input",
            type: "number",
            min: _ctx.min,
            max: _ctx.max,
            step: _ctx.step,
            disabled: _ctx.disabled,
            onInput: handleInputChange,
            onBlur: handleInputChange
          }, null, 40, _hoisted_4), [
            [
              vModelText,
              inputValue.value,
              void 0,
              { number: true }
            ]
          ]),
          createElementVNode("button", {
            type: "button",
            class: "amount-input__button amount-input__button--increment",
            disabled: !canIncrement.value,
            onClick: increment,
            "aria-label": "Increase amount"
          }, _cache[2] || (_cache[2] = [
            createElementVNode("span", null, "+", -1)
          ]), 8, _hoisted_5)
        ], 64))
      ], 2);
    };
  }
});

export { _sfc_main as default };
